import { createContext, useCallback, useContext, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [flyers, setFlyers] = useState([]);
  const [query, setQuery] = useState("");
  const [inquiryProduct, setInquiryProduct] = useState(null);

  const addItem = useCallback((product, color, sizeRun, boxSize, origin) => {
    const key = `${product.id}|${color}|${sizeRun}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, boxes: i.boxes + 1 } : i));
      }
      return [...prev, { key, product, color, sizeRun, boxSize, boxes: 1 }];
    });
    if (origin) {
      const id = `${Date.now()}-${Math.random()}`;
      const colorData = product.colors.find((c) => c.name === color) || product.colors[0];
      setFlyers((prev) => [...prev, { id, x: origin.x, y: origin.y, img: colorData.images.profile }]);
    }
  }, []);

  const removeFlyer = useCallback((id) => {
    setFlyers((prev) => prev.filter((f) => f.id !== id));
  }, []);

  const updateBoxes = useCallback((key, delta) => {
    setItems((prev) =>
      prev.map((i) => (i.key === key ? { ...i, boxes: Math.max(1, i.boxes + delta) } : i))
    );
  }, []);

  const removeItem = useCallback((key) => {
    setItems((prev) => prev.filter((i) => i.key !== key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(
    () => ({
      items,
      addItem,
      updateBoxes,
      removeItem,
      clear,
      drawerOpen,
      setDrawerOpen,
      flyers,
      removeFlyer,
      query,
      setQuery,
      inquiryProduct,
      setInquiryProduct,
    }),
    [items, drawerOpen, flyers, query, inquiryProduct, addItem, updateBoxes, removeItem, clear, removeFlyer]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
